import Form from '../../../../components/form';
import request from '../../../../utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'send_form',
      formParentCode: 'CRM20210105000000416',
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {},
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = '/dms/dmstransitorderdetail/updateTransitDelivery';
        const params = {
          transitDelivery: formData.transitDelivery,
          paperOrderCode: formData.paperOrderCode,
          id: this.formConfig.businessId,
        };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
